import { render } from "./MediumCircle.vue?vue&type=template&id=67231eaa"
const script = {}

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__